import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createCertificadoDigitalCadastro, updateCertificadoDigitalCadastro } from '../service';
import {
  CREATE_CERTIFICADO_DIGITAL_CADASTRO,
  CREATE_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
  CREATE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
  CREATE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE,
} from '@handler';
import {
  AlertSuccess,
  AlertError,
  AlertWarning,
} from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

/**
 * Verifica se deve disparar tracking de ativação do Monitoramento NFe
 * Regras:
 * - Criação: dispara se monitoraNfe === true
 * - Edição: dispara APENAS se houve transição false → true
 */
function shouldDispatchMonitoraNfeTracking(isCreating, previousValue, currentValue) {
  if (isCreating) {
    return currentValue === true;
  }

  if (previousValue === false && currentValue === true) {
    return true;
  }

  return false;
}

function* sagaCreateCertificadoDigitalCadastro(action) {
  yield put({ type: CREATE_CERTIFICADO_DIGITAL_CADASTRO_PENDING });

  try {
    if (action.data.senhaCertificadoTemp == '') {
      delete action.data.senhaCertificadoTemp;
    }
    if (action.data.tipoPessoa === 'FISICA'){
      action.data.cnpj = null;
    } else {
      action.data.cpf = null;
    }

    const isCreating = action.data.id === undefined || action.data.id === null;
    const previousMonitoraNfe = action.previousMonitoraNfe ?? false;
    const currentMonitoraNfe = action.data.monitoraNfe ?? false;

    if (isCreating) {
      yield call(createCertificadoDigitalCadastro, {
        ...action.data
      });
      trackingEventCX('action', MODULE_ACTIONS_ENUM.CERTIFICADO_DIGITAL_CRIAR);

      // Verifica se deve disparar tracking de MonitoraNfe
      if (shouldDispatchMonitoraNfeTracking(true, previousMonitoraNfe, currentMonitoraNfe)) {
        trackingEventCX('action', MODULE_ACTIONS_ENUM.FISCAL_CERTIFICADO_DIGITAL);
      }
    } else {
      yield call(updateCertificadoDigitalCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.CERTIFICADO_DIGITAL_EDITAR);

      // Verifica se deve disparar tracking de MonitoraNfe
      if (shouldDispatchMonitoraNfeTracking(false, previousMonitoraNfe, currentMonitoraNfe)) {
        trackingEventCX('action', MODULE_ACTIONS_ENUM.FISCAL_CERTIFICADO_DIGITAL);
      }
    }

    yield put({ type: CREATE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS, registro: action.data });

    if (!action.isCadastroRapido) {
      history.push('/fiscal/certificadoDigital');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE, registro: action.data });

    if (error.response.status !== undefined && error.response.status == 403) {
      AlertWarning('Sua licença atingiu o número máximo de certificados cadastrados. Para contratar mais certificados, contate o comercial da plataforma.');
    } else {
      if (error.response.status !== undefined && error.response.status == 400) {
        AlertWarning('Não foi possível salvar o certificado digital. Verifique se o CPF ou CNPJ já está cadastrado no sistema.');
      } else {
        AlertError('Falha ao salvar o registro! Tente novamente...');
      }
    }
  }

}

export default function* watchCreateCertificadoDigitalCadastro() {
  yield takeLatest(CREATE_CERTIFICADO_DIGITAL_CADASTRO, sagaCreateCertificadoDigitalCadastro);
}
